/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../redux/configureStore';
import Wrapper from '../../../../shared/components/Wrapper';
import CardTotalLimit from './components/CardTotalDebits';
import Frame from './components/Frame';
import LimitFilter from './components/LimitFilter';
import LimitTableList from './components/LimitTableList';

function Limit() {
  const LimitListContext = useSelector(
    (reducer: IReducer) => reducer.limitsApp
  );

  const loading = useMemo(() => {
    if (LimitListContext.isLoading === true) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [LimitListContext.isLoading]);

  const TableComponent = useMemo(() => {
    if (
      LimitListContext.limits === undefined ||
      (LimitListContext.limits.length === 0 &&
        LimitListContext.gotSuccess)
    ) {
      Swal.fire('Não há clientes');
      return <></>;
    }
    if (LimitListContext.isActive === false) {
      return <></>;
    }
    return (
      <>
        <CardTotalLimit />
        <LimitTableList />
      </>
    );
  }, [LimitListContext.limits]);

  return (
    <Frame.Base>
      <LimitFilter />
      {loading}
      {TableComponent}
    </Frame.Base>
  );
}

export default Limit;
